import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />

        <path
          d="M90 50c-8-12-24-22-40-22c-15 0-30 8-38 22s-8 30 2 44c10 14 26 22 44 22c14 0 28-6 38-16l-12-12c-7 7-18 12-28 10c-10-2-19-8-25-16c-5-8-5-20 0-28c6-8 15-14 25-16c10-2 21 3 28 10l12-12c-10-10-24-16-38-16c-18 0-34 8-44 22c-10 14-12 34-2 50c10 16 28 26 48 26c18 0 36-8 48-20l-10-14c-10 10-24 18-38 18c-14 0-28-8-34-18c-6-10-6-22 0-32c6-10 20-18 34-18c14 0 28 8 38 18l10-14z"
          fill="currentColor"
          transform="scale(0.5) translate(18, 20)"
        />

      </g>
    </g>
  </svg>
);

export default IconLogo;
